import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import config from '../../../constants/apiConfig';
import { useSelector } from 'react-redux';
import {
  selectIncidentGuid,
  selectUserGuid,
} from '../../../slices/commonSelectors';
import { toast } from 'react-toastify';
import {
  CreateSafetyMessageRequestBody,
  SafetyMessageDto,
} from '../../../types/iapBaseTypes';

export const keys = {
  safetyMessages: 'safetyMessages',
} as const;

export const useCreateSafetyMessage = () => {
  const queryClient = useQueryClient();
  const incidentId = useSelector(selectIncidentGuid);
  const userGuid = useSelector(selectUserGuid);

  return useMutation({
    mutationFn: async (
      data: Omit<CreateSafetyMessageRequestBody, 'incidentId' | 'userGuid'>
    ) => {
      const payload: CreateSafetyMessageRequestBody = {
        ...data,
        incidentId: incidentId!,
        userGuid: userGuid!,
      };

      const response = await axios.post<SafetyMessageDto>(
        config.apiGateway.ics_safety_messages,
        payload
      );
      return response.data;
    },
    onSuccess: () => {
      if (incidentId) {
        queryClient.invalidateQueries({
          queryKey: [keys.safetyMessages, incidentId],
        });
      }
      toast.success('Safety plan created successfully');
    },
    onError: (error: any) => {
      const errorMessage =
        error.response?.data?.error || 'Failed to create safety plan';
      toast.error(errorMessage);
    },
  });
};
